import http from '@/libs/javaAxios'

export default class accountApi extends http {
  /**
   * 交易密码-修改
   * @method post
   * @param password 新密码
   * @param old_password 原始密码
   *
   * 2026-10-17：支付密码统一为「客户端传明文、服务端只做一次 md5(明文+盐)」——
   * 与服务端 AccountServiceImplDingdang#verifyPassword 的校验式一致
   * （2026-10-13 起全端校验都按明文算，此前这里多 md5 了一层，导致设置后永远验不过）。
   */
  static tradePasswordEdit = ({ password, old_password }) => {
    const url = '/user/trade/password/edit';
    this.setLoginParams();
    const data = {
      password: password,
      old_password: old_password
    }
    return this.post(url, data);
  }

  /**
   * 交易密码-查询是否设置
   * @method post

   */
  static tradePasswordCheck = () => {
    const url = '/user/trade/password/check';
    this.setLoginParams();
    return this.post(url);
  }

  /**
   * 交易密码-设置
   * @method post
   * @param password 密码
   * @param send_code 验证码

   */
  static tradePasswordAdd = ({ password, send_code }) => {
    const url = '/user/trade/password/add';
    this.setLoginParams();
    const data = {
      // 2026-10-17：改为传明文（服务端只做一次 md5(明文+盐) 并强校验 6 位数字）；
      // 原来传 MD5.hexMD5(password) 会让库里存成 md5(md5(明文)+盐)，
      // 而转账/提现校验用 md5(明文+盐) ⇒ 设置后永远验不过。
      password: password,
      send_code: send_code
    }
    return this.post(url, data, true, true);
  }

  /**
   * 交易密码-验证交易密码是否正确
   * @method post
   * @param password 密码

   */
  static tradePasswordVerify = ({ password }) => {
    const url = '/user/trade/password/verify';
    this.setLoginParams();
    const data = {
      // 2026-10-17：与其他支付密码入口统一为明文（本方法当前无页面调用）
      password: password
    }
    return this.post(url, data);
  }

  /**
   * 充值记录
   * @method post
   * @param page 页码
   * @param page_size 每页记录数

   */
  static accountRecharge = ({ page, page_size }) => {
    const url = '/user/account/recharge';
    this.setLoginParams();
    return this.post(url, { page, page_size }, true);
  }

  /**
   * 提现记录
   * @method post
   * @param page 页码
   * @param page_size 每页记录数

   */
  static accountWithdraw = ({ page, page_size }) => {
    const url = '/user/account/withdraw';
    this.setLoginParams();
    return this.post(url, { page, page_size }, true);
  }

  /**
   * 用户绑卡信息
   * @method post

   */
  static accountBank = () => {
    const url = '/user/account/bank';
    this.setLoginParams();
    return this.post(url);
  }

  /**
   * 账单
   * @method post
   * @param year 年份
   * @param month 月份
   * @param page 页码
   * @param page_size 每页记录数

   */
  static accountDetail = ({ year, month, page, page_size }) => {
    const url = '/user/account/detail';
    this.setLoginParams();
    return this.post(url, { year, month, page, page_size }, true);
  }

  /**
   * 账单-统计
   * @method post
   * @param year 年份
   * @param month 月份

   */
  static accountDetailTotal = ({ year, month }) => {
    const url = '/user/account/detail/total';
    this.setLoginParams();
    return this.post(url, { year, month });
  }
}